class PrimarySearch {

  constructor(){
    this._init();
  }

  _init(){

    document.addEventListener('DOMContentLoaded', (event) => {
    	jQuery('div[data-trigger="primary-search"]').click(function(){
    		var stateElement = jQuery('div[data-target="primary-search"]').attr('data-state');
    		if(stateElement === 'active'){
    			jQuery('div[data-target="primary-search"]').attr('data-state','inactive');
    		} else {
    			jQuery('div[data-target="primary-search"]').attr('data-state','active');
    		}    		
    	});
    });
  }


}

export let primarySearch = new PrimarySearch();